import { getCenterFrame } from '@pages/cameras/details/utils';
import color from '@theme/Colors';
import React, { FC, Fragment } from 'react';
import { Circle, Line, Text } from 'react-konva';
import { GeoZoneProps } from '../../../solar/components/GeoZonesHistoriesCameraSolar';
import { GeoZones, GeoZoneType } from '@EcamModel/model';
import { Paging } from '@Core';

interface Props extends GeoZoneProps {
    listGeoZonesByView: GeoZones[];
    isCameraView: boolean;
}
const GeoZonesHistoriesCameraPTZ: FC<Props> = (props) => {
    const { frame, index, hoveredFrame, listGeoZonesByView, isCameraView } = props;
    const center = getCenterFrame(frame);
    const conditionHoveredIndex = hoveredFrame === index && isCameraView;
    const matchingGeoZone = listGeoZonesByView?.find((zone) => zone.Id === frame[0].geoZoneId);
    const strokeColor = matchingGeoZone?.GeoZoneType === GeoZoneType.Detail ? color.accentPink : color.primary;

    return (
        <Fragment key={`frame-${index}`}>
            <Line
                points={frame.flatMap((point) => [point.x, point.y])}
                stroke={strokeColor}
                strokeWidth={3}
                shadowColor={matchingGeoZone?.GeoZoneType === GeoZoneType.Detail ? color.accentPink : '#93D500'}
                shadowBlur={conditionHoveredIndex ? 15 : 0}
                fill="rgba(0, 0, 0, 0.12)"
                closed={true}
            />
            <Circle x={center.x} y={center.y} radius={15} fill={color.white} />
            <Text
                x={center.x}
                y={center.y}
                text={String(`${index + 1}`)}
                fontSize={14}
                fill={color.textPrimary}
                align={'center'}
                verticalAlign={'middle'}
                offsetX={4}
                offsetY={6}
            />
        </Fragment>
    );
};

export default GeoZonesHistoriesCameraPTZ;
